import React, { useState } from 'react';

import { StyledProductsFilters } from './ProductsFilters.styles';

import { ProductsFiltersProps } from './ProductsFilters.types';

import { CustomSelector } from '../../';

const ProductsFilters = ({
  filterList = [],
  activeFilterList = [],
  handleChangeActiveFilterList = () => {},
  label,
  hasUniqueActive = false,
  hasAtLeastOneActive = false,
  componentClassname = 'products-filters',
  customClassnames = '',
  customStyle = '',
  ...props
}: ProductsFiltersProps) => {
  const [activeFilters, setActiveFilters] =
    useState<string[]>(activeFilterList);

  const handleClick = (filterClicked: string, isActive: boolean) => {
    const allFiltersRemoved =
      activeFilters.length === 1 && activeFilters.includes(filterClicked);

    if (hasAtLeastOneActive && allFiltersRemoved) {
      return;
    }

    setActiveFilters((prev) => {
      if (hasUniqueActive) {
        return [isActive ? filterClicked : null];
      } else {
        return isActive
          ? [...prev, filterClicked]
          : prev.filter((filter) => filter !== filterClicked);
      }
    });

    handleChangeActiveFilterList(filterClicked, isActive);
  };

  return (
    <StyledProductsFilters
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {label && <div className={`${componentClassname}__label`}>{label}</div>}
      <div className={`${componentClassname}__list`}>
        {filterList?.map((filter: string) => (
          <CustomSelector
            key={filter}
            customClassnames={`${componentClassname}__selector`}
            value={filter}
            isActive={activeFilters.includes(filter)}
            onSelectorClick={handleClick}
          />
        ))}
      </div>
    </StyledProductsFilters>
  );
};
ProductsFilters.displayName = 'ProductsFilters';

export default ProductsFilters;
